<template>
  <span class="matchTimer">
   {{ matchTimer ? matchTimer + (Number.isInteger(matchTimer) ? "'" : '') : '' }}
  </span>

</template>

<script>
import moment from 'moment';
export default {
    props: ["match", "statuses"],
    data() {
        return {
          eventDescription: null,
          matchMinute: null,
          matchTimer: null,
          timerFn: undefined
        }
    },
    watch: {
      match() {
        // re-init the component
        this.init();
      }
    },
    methods: {
        init() {
            console.log('Initializing matchtimer');
            switch (this.match.statusId) {
              case this.statuses.FIRST_HALF:
                this.updateMatchTime(1, this.match.statusTime);
                break;
              case this.statuses.SECOND_HALF:
                this.updateMatchTime(46, this.match.statusTime);
                break;
              case this.statuses.IN_FIRST_EXTRA_PERIOD:
                this.updateMatchTime(91, this.match.statusTime);
                break;
              case this.statuses.IN_SECOND_EXTRA_PERIOD:
                this.updateMatchTime(106, this.match.statusTime);
                break;
              case this.statuses.ENDED:
              case this.statuses.ENDED_AFTER_EXTRA_TIME:
              case this.statuses.ENDED_AFTER_PENALTIES:
              case this.statuses.FINISHED:
                this.updateMatchTime(-1, this.match.statusTime);
                this.matchTimer = 'FT'
                break;
              default:
                if (
                  this.match.statusId > 0 &&
                  !(this.match.status) &&
                  this.match.status !== ''
                ) {
                  // Don't start timer
                  this.updateMatchTime(
                    -1,
                    this.match.statusTime,
                  );
                }
                break;
            }
        },
        getExtraTimeText() {
            switch (this.match.statusId) {
              case this.statuses.FIRST_HALF:
                return "45'+";
              case this.statuses.SECOND_HALF:
                return "90'+";
              case this.statuses.IN_FIRST_EXTRA_PERIOD:
                return "105'+";
              case this.statuses.IN_SECOND_EXTRA_PERIOD:
                return "120'+";
              default:
                return '';
            }
        },
        updateMatchTime(matchMinute, matchTime) {
          this.matchMinute = matchMinute;

          if (matchMinute >= 0) {
              var minuteOffset = moment(new Date()).diff(moment(matchTime), 'minutes');
              this.matchTimer = matchMinute + minuteOffset
              this.incTimer();
              console.log('Started clock for game ' + this.eventDescription );
          }

          else {
            if (this.timerFn != undefined) {
              clearTimeout(this.timerFn)
              console.log('Stopping clock for game ' + this.eventDescription );
            }
          }

        },
        shouldIncreaseMatchClock() {
          var increase = false;

          if (this.match.statusId === this.statuses.FIRST_HALF) {
            if (this.matchTimer < 45) {
              increase = true;
            }
          } else if (this.match.statusId === this.statuses.SECOND_HALF) {
            if (this.matchTimer < 90) {
              increase = true;
            }
          } else if (
            this.match.statusId === this.statuses.IN_FIRST_EXTRA_PERIOD
          ) {
            if (this.matchTimer < 105) {
              increase = true;
            }
          } else if (
            this.match.statusId === this.statuses.IN_SECOND_EXTRA_PERIOD
          ) {
            if (this.matchTimer < 120) {
              increase = true;
            }
          }
          return increase;
        },
        incTimer() {
          this.timerFn = setTimeout(() => {
            if (this.shouldIncreaseMatchClock()) {
              var minuteOffset = moment(new Date()).diff(moment(this.match.statusTime), 'minutes');
              this.matchTimer = this.matchMinute + minuteOffset
              this.incTimer();
            }
            else {
              // Om perioden är i överttid, sluta räkna tiden och visa en symbol för övertid
              this.matchTimer = this.getExtraTimeText();
              clearTimeout(this.timerFn)
              console.log('Stopping clock for game ' + this.eventDescription );
            }
          }, 60000)
        }
    },
    mounted() {
      if (this.match && this.statuses)
       this.eventDescription = this.match.participants[0].name + ' - ' + this.match.participants[1].name;
       this.init()
    }
}
</script>
